import React from 'react';
import { FormState } from 'react-hook-form';
import { CreateJobDto } from '../../../../../../services/applicant_tracking/JobService/CreateJobDto';
import {
  SetupFooterButtonType,
  SetupPageFooter,
} from '../../../../../../components/SetupPageFooter';
import { JobDetails } from '../../../../../../services/applicant_tracking/JobService/EditJobDto';
import {
  SetupHeaderButtonType,
  SetupPageHeader,
} from '../../../../../../components/SetupPageHeader';

interface PropTypes {
  formState: FormState<CreateJobDto>;
  jobDetails: JobDetails;
  onCancel: () => void;
  onSave: () => void;
  onNext: () => void;
  isEditFlow: boolean;
  isLoading: boolean;
  children: React.ReactNode;
}

export function JobDetailsLayout(props: PropTypes) {
  const isLoadingOrFormInvalid = props.isLoading || !props.formState.isValid;
  const saveAsDraft: SetupFooterButtonType = {
    title: 'Save as Draft',
    type: 'Save',
    action: props.onSave,
    disabled: isLoadingOrFormInvalid,
  };

  const nextButton: SetupHeaderButtonType = {
    title: 'Next',
    type: 'Navigate',
    action: props.onNext,
    disabled: isLoadingOrFormInvalid,
  };

  const saveButtonText =
    props.isEditFlow && props.jobDetails?.status === 'published'
      ? 'Save and Publish'
      : 'Save and Continue';

  const saveAndContinue: SetupFooterButtonType = {
    title: saveButtonText,
    type: 'Save',
    disabled: isLoadingOrFormInvalid,
  };

  return (
    <>
      <SetupPageHeader
        title='Job Details'
        firstItems={props.isEditFlow ? [nextButton] : [saveAsDraft]}
        intermediateItems={[
          {
            title: 'Cancel',
            type: 'Cancel',
            action: props.onCancel,
          },
          {
            title: saveButtonText,
            type: 'Save',
            disabled: isLoadingOrFormInvalid,
          },
        ]}
      />
      {props.children}
      {!props.isLoading && (
        <SetupPageFooter
          classNames='mt-4'
          firstItem={saveAndContinue}
          lastItem={props.isEditFlow ? null : saveAsDraft}
        />
      )}
    </>
  );
}
